import { FC, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import Breadcrumb from '../../Components/Breadcrumb';
import ShopService from './service';

import {
    Link, useNavigate
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

const ShopList: FC = () => {  
    let idToModInit: any = null;
    const [ shops, setShops ] = useState( [] );
    const [ idToMod, setIdToMod ] = useState(idToModInit);
    const [ loading, setLoading ] = useState(false);
    const shopService = new ShopService();

    const navigate = useNavigate();
    const { t } = useTranslation();

   

    const getShops = () => {
        setLoading(true);
        shopService.getShops().then(async function (response: any) {
            console.log(response);
            setShops(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    useEffect( function() { 
        getShops();
    }, []);

    const columns = [
        {
            name: `${t('Libellé')}`,
            selector: (row: any) => row.libBoutique,
        },
        {
            name: `${t('Contact')}`,
            selector: (row: any) => row.contactBoutique,
        },
        {
            name: `${t('Adresse')}`,
            selector: (row: any) => row.adresseBoutique,
        },
        {
            name: `${t('Taxe')}`,
            selector: (row: any) => row.taxeBoutique,
        },
        {
            name: `${t('Options')}`, 
            selector: (row: any) => (
                <>
                    <button type="button" onClick={event => {
                        navigate('/boutique/edit/'+row.id.toString());
                    }}
                        className="btn waves-effect waves-light btn-success">
                            <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-pencil"></i></span>
                    </button>
                    <button type="button" onClick={event => {  }}
                       className="btn waves-effect waves-light btn-danger"> 
                                <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-trash"></i></span>
                            
                    </button> 
                </>
            )
        }
    ];
    

    return (
            <> 
                <Breadcrumb />
 
                <div className="container-fluid">
    
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="btn-list">
                                    <button type="button" onClick={ event => getShops() }
                                        className="btn waves-effect waves-light btn-danger">
                                            { t('Actualiser') }
                                        </button>
                                        <Link type="button" to="/boutique/create"
                                            className="btn waves-effect waves-light btn-primary">
                                                {
                                                    t('Ajouter une boutique')
                                                }
                                        </Link>
                                    </div>
                                    <br />
                                    <br />
                                    {/* <h4 className="card-title">Zero Configuration</h4>
                                    <h6 className="card-subtitle">DataTables has most features enabled by default, so all you
                                        need to do to use it with your own tables is to call the construction
                                        function:<code> $().DataTable();</code>. You can refer full documentation from here
                                        <a href="https://datatables.net/">Datatables</a></h6> */}
                                    <div className="table-responsive">
                                        <DataTable
                                            responsive={true}
                                            className="table table-striped table-bordered"
                                            columns={columns}
                                            data={shops}
                                            progressPending={loading}
                                            pagination
                                        />
                                        </div>
                                    </div>
                                </div> 
                        </div> 
                    </div>

                </div>   
            </>                   

    );
}

export default ShopList